<template>
<div class="page page_hezuo">
    <div class="bg">欢迎加入时代记忆分销商大家庭</div>
    <!-- 基本信息 -->
    <div>
        <div class="step">
            <!-- 进行状态 加active类 ; 非进行状态 不加-->
            <div class="step_item active">
                <div class="step_name">填写信息</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">审核</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
            <div class="step_item">
                <div class="step_name">成功入驻</div>
                <div class="step_icon">
                    <div class="icon"></div>
                </div>
            </div>
        </div>
        <!-- 表单 -->
        <div class="form_wrap" v-if="stepNum == 1">
			<div class="item flex" @click="blockPicker = true">
                <div class="item_l">
                    <div class="title">代理区域</div>
					<van-field v-model="selectedBlock.name" placeholder="请选择" readonly/>
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex" @click="rolePicker=true">
                <div class="item_l">
                    <div class="title">入驻类型</div>
                    <div class="name">{{ selectedRole.name }}</div>
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item flex" @click="agentPicker=true">
                <div class="item_l">
                    <div class="title">入驻角色</div>
                    <div class="name">{{ selectedAgent.name }}</div>
                </div>
                <div class="item_r">选择</div>
            </div>
			<div class="item flex" @click="parkPicker=true" v-if="selectedBlock && selectedBlock.type == 2">
                <div class="item_l">
                    <div class="title">园区</div>
                    <van-field v-model="parkName" placeholder="请选择" readonly/>
                </div>
                <div class="item_r" @click="parkPicker=true">选择</div>
            </div>
			<div class="item flex" @click="firstLevelPicker = true" v-if="selectedBlock.type != 2">
                <div class="item_l">
                    <div class="title">选择一级分销商</div>
					<van-field v-model="firstLevelName" placeholder="请选择" readonly/>
                </div>
                <div class="item_r">选择</div>
            </div>
            <div class="item" v-if="selectedRole.type == 1">
                <div class="title">企业名称</div>
                <div class="name">
                    <van-field v-model="company" placeholder="请填写企业名称" />
                </div>
            </div>
            <div class="item" v-if="selectedRole.type == 1">
                <div class="title">机构代码</div>
                <div class="name">
                    <van-field v-model="companyCode" placeholder="请填写企业机构代码" />
                </div>
            </div>
            <div class="item" v-if="selectedRole.type == 1">
                <div class="title">上传个体工商户营业执照</div>
                <div class="upload_images">
					<div class="img_box" v-for="(item,index) in lienceList" :key="index">
                        <div class="img_bu">
							<img :src="imageUrl+item" alt="" class="image">
							<van-icon name="close" size="0.4rem" color="rgba(211, 68, 68, 1)" @click="delLience(index)" />
                        </div>
                    </div>
                    <van-uploader :after-read="onLienceRead" accept max-count="1" class="icon-add" v-if="lienceList.length == 0">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
			<div class="item">
                <div class="title">店铺名称</div>
                <div class="name">
                    <van-field v-model="nickname" placeholder="请输入" />
                </div>
            </div>
			<div class="item">
                <div class="title">店铺简介</div>
                <div class="name">
                    <van-field v-model="describe" placeholder="请输入" />
                </div>
            </div>
			<div class="item">
                <div class="title">店内图片</div>
                <div class="upload_images">
					<div class="img_box" v-for="(item,index) in albumList" :key="index">
                        <div class="img_bu">
							<img :src="imageUrl+item" alt="" class="image">
							<van-icon name="close" size="0.4rem" color="rgba(211, 68, 68, 1)" @click="delAlbum(index)" />
                        </div>
                    </div>
                    <van-uploader :after-read="onAlbumRead" accept max-count="6" class="icon-add" v-if="albumList.length < 6">
                        <div class="addPhone"></div>
                    </van-uploader>
                </div>
            </div>
        </div>
		<div class="form_wrap" v-if="stepNum == 2">
			<div class="item">
                <div class="title">姓名</div>
                <div class="name">
                    <van-field v-model="legal_person" placeholder="请填写您的真实姓名" />
                </div>
            </div>
            <div class="item">
                <div class="title">手机号</div>
                <div class="name">
                    <van-cell :title="phone">
						<template #right-icon>
							<span @click="getCode">{{ codeLoading ? '已发送' : '发送验证码' }}</span>
						</template>
					</van-cell>
                </div>
            </div>
			<div class="item">
                <div class="title">手机验证码</div>
                <div class="name">
                    <van-field v-model="phoneCode" placeholder="请输入" />
                </div>
            </div>
			<div class="item">
                <div class="title">身份证号</div>
                <div class="name">
                    <van-field v-model="id_card" placeholder="请输入" />
                </div>
            </div>
			<div class="item flex" @click="areaPicker=true">
                <div class="item_l">
                    <div class="title">省市区</div>
                    <van-field v-model="area" placeholder="请选择" readonly />
                </div>
                <div class="item_r" @click="areaPicker=true">选择</div>
            </div>
            <div class="item">
                <div class="title">详细信息</div>
                <div class="name">
                    <van-field v-model="street" placeholder="如道路、门牌号、小区、楼栋号等" />
                </div>
            </div>
			<div class="item">
                <div class="title">银行卡号</div>
                <div class="name">
                    <van-field v-model="card_number" placeholder="请输入" />
                </div>
            </div>
			<div class="item">
                <div class="title">开户行</div>
                <div class="name">
                    <van-field v-model="opening_bank" placeholder="请输入" />
                </div>
            </div>
			<div class="item">
                <div class="title">上传身份证正反面照片</div>
                <div class="upload_images has-name">
					<div class="up-name">正面</div>
					<div class="upload_images">
						<div class="img_box" v-for="(item,index) in photoFacadeList" :key="index">
							<div class="img_bu">
								<img :src="imageUrl+item" alt="" class="image">
								<van-icon name="clear" size="0.4rem" color="rgba(211, 68, 68, 1)" @click="delFacade(index)" />
							</div>
						</div>
						<van-uploader :after-read="onFacadeRead" accept max-count="1" class="icon-add" v-if="photoFacadeList.length < 1">
							<div class="addPhone"></div>
						</van-uploader>
					</div>
                </div>
                <div class="upload_images has-name">
					<div class="up-name">反面</div>
					<div class="upload_images">
						<div class="img_box" v-for="(item,index) in photoBackList" :key="index">
							<div class="img_bu">
								<img :src="imageUrl+item" alt="" class="image">
								<van-icon name="clear" size="0.4rem" color="rgba(211, 68, 68, 1)" @click="delBack(index)" />
							</div>
						</div>
						<van-uploader :after-read="onBackRead" accept max-count="1" class="icon-add" v-if="photoBackList.length < 1">
							<div class="addPhone"></div>
						</van-uploader>
					</div>
                </div>
            </div>
		</div>
        <!-- 协议 -->
        <div class="xieyi" v-if="selectedBlock.type == 1">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(6)">“分销商入驻协议”</span></div>
        </div>
		<!-- 园区代理商协议 -->
        <div class="xieyi" v-if="selectedBlock.type == 2">
            <van-checkbox v-model="checked_xieyi">
                <template #icon="props">
                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
            </van-checkbox>
            <div class="tips">我已经阅读并同意<span class="xieyi_type" @click="goSinglePage(12)">“分销商入驻园区协议”</span></div>
        </div>
		<!-- 下一步 -->
		<div class="big_btn" @click="goNextStep" v-if="stepNum == 1">下一步</div>
        <!-- 入驻 -->
		<div class="btns-wrap" v-if="stepNum == 2">
			<div class="big_btn pre-btn" @click="stepNum = 1">上一步</div>
			<div class="big_btn" @click="applySeller">入驻</div>
		</div>
        
    </div>
    <!-- 入驻类型弹层 -->
    <van-popup v-model="rolePicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="roleList"
			value-key="name"
			@cancel="rolePicker = false"
			@confirm="confrimRole"
		/>
    </van-popup>
    <!-- 代理商身份弹层 -->
    <van-popup v-model="agentPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="agentList"
			value-key="name"
			@cancel="agentPicker = false"
			@confirm="confrimAgent"
		/>
    </van-popup>
    <!-- 地区弹层 -->
    <van-popup v-model="areaPicker" position="bottom">
        <van-area :area-list="areaList" @confirm="confrimArea" @cancel="areaPicker=false" />
    </van-popup>
	<!-- 代理区域弹层 -->
	<van-popup v-model="blockPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="blockList"
			value-key="name"
			@cancel="blockPicker = false"
			@confirm="confrimBlock"
		/>
    </van-popup>
	<!-- 选择园区 -->
	<van-popup v-model="parkPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="parkList"
			value-key="name"
			@cancel="parkPicker = false"
			@confirm="confrimPark"
		/>
    </van-popup>
	<!-- 选择分销等级 -->
	<!-- <van-popup v-model="levelPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="levelAgentList"
			value-key="name"
			@cancel="levelPicker = false"
			@confirm="confrimLevel"
		/>
    </van-popup> -->
	<!-- 选择一级分销商 -->
	<van-popup v-model="firstLevelPicker" position="bottom">
		<van-picker
			show-toolbar
			:columns="firstLevelAgentList"
			value-key="nickname"
			@cancel="firstLevelPicker = false"
			@confirm="confrimFirstLevel"
		/>
    </van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import Field from 'vant';
import { Uploader } from 'vant';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			delyTime: 60, // 获取验证间隔时间 s
			codeLoading: false, // 验证码加载状态
			stepNum: 1, // 分两个表单 1 、2
			lienceList: [],
			photoBackList: [],
			photoFacadeList: [],
			describe: null,
			nickname: null,
			albumList: [],
			card_number: null,
			opening_bank: null,
			id_card: null,
			phoneCode: null,
            publicPath: process.env.BASE_URL,
            activeIcon: process.env.BASE_URL + 'statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + 'statics/images/inactive.png',
            checked_xieyi: true,
			rolePicker: false,
            roleList: [{
				name: '个人',
				type: 0
			},{
				name: '公司',
				type: 1
			}],
			selectedRole: {
				name: '个人',
				type: 0
			},
			agentPicker: false,
			agentList: [{
				name: '导游',
				type: 1
			},{
				name: '民宿',
				type: 2
			},{
				name: '景点',
				type: 3
			}],
			selectedAgent: {
				name: '导游',
				type: 1
			},
            invoice: '',
            nickname: '',
            legal_person: '',
            phone: '',
            type: '1',
            street: '',
            area: '',
            area_name1: '',//省
            area_name2: '',//市
            area_name3: '',//区
            areaList: {},
            areaPicker: false,
            token: '',
            legal_photo_facade: null,//身份证正面照片
            legal_photo_back: null,//身份证背面照片
            intelligence: '',//资质证书
            company: '',//公司名
            companyCode: '',//企业机构代码
            imageUrl: Vue.prototype.$publicData.uploadImage,
			imglist:[],
			blockPicker: false, // 代理区域弹层
			blockList: [
				{
					type: 1,
					name: '地区'
				},
				{
					type: 2,
					name: '园区'
				}
			],
			selectedBlock: {
					type: 1,
					name: '地区'
			}, // 选中的代理区域
			parkName: null, // 园区
			selectedPark: null, // 园区
			parkPicker: false, // 园区弹层
			parkList: null, // 园区数据
			park_uuid: null,
			levelName: null, // 分销等级
			levelPicker: false, // 选择分销等级弹层
			levelAgentList: [
				{
					type: 1,
					name: '一级分销'
				},
				{
					type: 2,
					name: '二级分销'
				},
			],
			selectedLevel: null,
			firstLevelPicker: false, // 选择一级分销商弹层
			firstLevelName: null,
			firstLevelAgentList: null,
			selectedFirstLevel: null
        };
    },
    created: function () {
        if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
            //设置导航栏
            var params = {'data':{'naviTitle':'申请成为匠人'}}
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getUserData()
					this.getAreaData()
					this.getParkData()
					this.getFirstagentList()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getUserData()
			this.getAreaData()
			this.getParkData()
			this.getFirstagentList()
        }
        console.log('this.addressId:'+this.addressId)
	},
	mounted: function(){
		
	},
    methods: {
		/**
		 * @name: 获取验证码
		 * @return {*}
		 * @desc: 
		 */		
		getCode(){
			let that = this;
			if(that.codeLoading){
				return;
			};
			let params = {
				phone: that.phone,
				type: 0 // type: 1 // 0普通 1修改手机号 2小程序绑定手机号
			};
			that.codeLoading = true;
			that.$api.user.code(params).then(res=>{
				if(res.code == 200){
					that.$toast('已发送');
					let s = setInterval(function () {
                        let dely1 = parseInt(that.delyTime) - 1;
                        that.delyTime = dely1;
                        // console.log(dely1);
                        if (dely1 == 0) {
                            clearInterval(s);
                            that.codeLoading = false;
							that.delyTime = 60;
                        }
                    }, 1000);
				}
			})	
		},
		/**
		 * @name: 下一步
		 * @return {*}
		 * @desc: 
		 */		
		goNextStep(){
			if(this.selectedBlock.type == 1 && !this.firstLevelName){
				this.$toast("请选择一级分销商");
				return;
			};
			if(this.selectedBlock.type == 2 && !this.parkName){
				this.$toast("请选择园区");
				return;
			};
			if(!this.nickname){
				this.$toast("请填写店铺名称");
				return;
			};
			if(!this.describe){
				this.$toast("请填写店铺简介");
				return;
			};
			if(this.selectedRole.type == 1){
				if(!this.company){
					this.$toast("请填写企业名称");
					return;
				};
				if(!this.companyCode){
					this.$toast("请填写企业机构代码");
					return;
				};
				if(this.lienceList.length == 0){
					this.$toast("请上传个体工商户营业执照");
					return;
				};
			};
			this.stepNum = 2;
		},
		/**
		 * @name: 上传店内图片
		 * @param {*} file
		 * @return {*}
		 * @desc: 
		 */		
		onAlbumRead(file){
			this.$api.index.uploadImage({
				imgFile: file.content
			}).then(res => {
				if (res.code == 200) {
					let url = res.result.url;
					if(this.albumList.length < 6){
						this.albumList.push(url);
					}
				}
			});
		},
		/**
		 * @name: 删除店内图片
		 * @param {*} index
		 * @return {*}
		 * @desc: 
		 */		
		delAlbum(index){
			this.albumList.splice(index,1);
		},
        getUserData() {
            if (this.token == null) {
                return
            }
            var params = {
                token: this.token
            }
            this.$api.user.index(params).then(res => {
                if (res.code == 200) {
                    this.phone = res.result.info.users.username
                } 
            })
        },
        getAreaData() {
            var params = {
            }
            this.$api.address.areaList(params).then(res=>{
                if (res.code == 200) {
                    var area = JSON.parse(res.result)
                    this.areaList = area.areaList
                    // console.log(this.areaList)
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 选角色 公司入驻还是个人入驻
        confrimRole(val) {
			this.selectedRole = val
            this.rolePicker = false;
        },
        // 选入驻身份
        confrimAgent(val) {
            this.selectedAgent = val
            this.agentPicker = false
        },
        // 确认选中地区
        confrimArea(data) {
            this.areaPicker = false;
            var area = ''
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                if (i == 0) {
                    this.area_name1 = item.code
                } else if (i == 1) {
                    this.area_name2 = item.code
                } else if (i == 2) {
                    this.area_name3 = item.code
                }
                area += item.name
            }
            this.area = area
        },
        // 图片身份证正面上传
        onFacadeRead: function (file) {
			this.$api.index.uploadImage({
				imgFile: file.content
			}).then(res => {
				if (res.code == 200) {
					this.photoFacadeList.push(res.result.url);
				}
			});
        },
		/**
		 * @name: 删除身份证 正面
		 * @return {*}
		 * @desc: 
		 */		
		delFacade(index){
			this.photoFacadeList.splice(index,1);
		},
        // 图片身份证反面上传
        onBackRead: function (file) {
			this.$api.index.uploadImage({
				imgFile: file.content
			}).then(res => {
				if (res.code == 200) {
					this.photoBackList.push(res.result.url);
				}
			});
        },
		/**
		 * @name: 删除身份证 反面
		 * @return {*}
		 * @desc: 
		 */		
		delBack(index){
			this.photoBackList.splice(index,1);
		},
        // 营业执照上传
        onLienceRead: function (file) {
			this.$api.index.uploadImage({
				imgFile: file.content
			}).then(res => {
				if (res.code == 200) {
					this.lienceList.push(res.result.url)
				}
			});
		},
		/**
		 * @name: 删除执照
		 * @return {*}
		 * @desc: 
		 */		
		delLience(index){
			this.lienceList.splice(index,1);
		},
		// 确认 代理区域
		confrimBlock(val){
			// console.log('val---',val)
			this.selectedBlock = val;
			this.blockPicker = false;
			// 清空firstLevelName,重新获取所属一级代理商
			this.firstLevelName = null
			this.getFirstagentList()
			// 清空所选园区
			this.parkName = null;
			// 清空地区
			this.area = null;
		},
		// 获取园区类型
		getParkData(){
			var params = {
				token: this.token
			}
			this.$api.tradesman.getTradesmanPark(params).then(res=>{
				if(res.code == 200){
					this.parkList = res.result
				}
			})
		},
		// 选择园区类型
		confrimPark(val){
			// console.log('confrimPark',val)
			this.selectedPark = val
			this.parkName = val.name
			if(val.park_uuid != 0){
				this.park_uuid = val.park_uuid
			}
			this.parkPicker = false
			// 清空firstLevelName,重新获取所属一级代理商
			this.firstLevelName = null
			this.getFirstagentList()
		},
        /**
         * @name: 提交申请信息
         * @return {*}
         * @desc: 
         */		
        applySeller() {
			let that = this;
			// 协议必须勾选
			if(!this.checked_xieyi){
				this.$toast('请勾选协议')
				return
			};
			// 姓名必填
			if(!this.legal_person){
				this.$toast('请填写姓名')
				return
			};
			// 手机验证码必填
			if(!this.phoneCode){
				this.$toast('请填写手机验证码');
				return
			};
			// 个人必填 姓名，卡号，身份证号，手机号
			if(this.selectedRole.type == 0 && !this.id_card){
				this.$toast('请填写身份证号');
				return;
			};
			if (this.area_name1 == null || this.area_name1 == undefined || this.area_name1 == '') {
				this.$toast('请选择地区');
				return;
			};
			if(!this.street){
				this.$toast('请填写详细信息');
				return;
			};
			if(!this.card_number){
				this.$toast('请填写银行卡号');
				return;
			};
			// 企业必填 姓名、卡号、开户行
			if(this.selectedRole.type == 1 && !this.opening_bank){
				this.$toast('请填写开户行');
				return;
			};
			// 身份证照片
			if(this.photoFacadeList.length == 0 || this.photoBackList.length == 0){
				this.$toast('请上传身份证照片');
				return;
			};
            let params = {
                token: this.token,
				code: this.phoneCode,
				in_type: this.selectedRole.type,
				type: this.selectedAgent.type,
				area1: this.area_name1,
				area2: this.area_name2,
				area3: this.area_name3,
				address: this.street,
				first_agent_uuid: this.selectedFirstLevel ? this.selectedFirstLevel.first_agent_uuid : '',
				park_uuid: this.park_uuid ? this.park_uuid : '',
				name: this.legal_person,
				phone: this.phone,
				nickname: this.nickname,
				describe: this.describe,
				company_code: this.companyCode,
				legal_photo_facade: this.photoFacadeList[0],
				legal_photo_back: this.photoBackList[0],
				company_photo: this.lienceList.length ? this.lienceList[0] : '',
				album: this.albumList.length ? this.albumList.join(',') : '',
				card_number: this.card_number ? this.card_number : '',
				opening_bank: this.opening_bank ? this.opening_bank : '',
				id_card: this.id_card ? this.id_card : ''
			};
			// 申请二级分销商
			this.$api.my.applyAgent(params).then(res=>{
				if (res.code == 200) {
					this.$toast(res.message)
					this.getApplyStatus(3,function(){
						if ( userAgent && userAgent.indexOf('shidaijiyi') != -1 ) {
							//返回上级页面
							var params = {'data':{}}
							that.$bridge.callhandler('sdjy://public/back', params, (data) => {

							})
						} else {
							that.$router.back()
						}
					})
				} else {
					this.$toast(res.message?res.message:res.msg)
				}
			})
			localStorage.setItem('agent_level',3);
		},
		// 获取申请角色的审核状态
		getApplyStatus(type,callback) {
            var params = {
				type: type, // 1匠人2供应商3二级分销商4城市合伙人, 5一级分销商
				token: this.token
			}
			this.$api.my.roleStatus(params).then(res => {
                    if (res.code == 200) {
						//res.result 0认证中1认证通过2未通过3未申请
						localStorage.setItem('agent_apply_status',res.result)
						callback()
                    }
                })
        },
		// 协议  1 平台服务协议;2 供应商入驻协议;3 匠人入驻协议; 4 帮助中心 ; 5合伙人入驻协议; 6 代理商入驻协议
		goSinglePage(id){
			this.$router.push({
				path: '/single/page',
				query: {
					id: id
				}
			})
		},
		// 确认分销等级
		confrimLevel(val){
			this.selectedLevel = val
			this.levelName = val.name
			this.levelPicker = false
		},
		// 确认一级分销商
		confrimFirstLevel(val){
			this.selectedFirstLevel = val
			this.firstLevelName = val.nickname
			this.firstLevelPicker = false
		},
		// 获取一级分销商列表
		getFirstagentList(){
			var params = {
				token: this.token,
				type: this.selectedBlock.type == 1 ? 0 : 1 // 0 地区 1园区
			}
			if(this.park_uuid){
				params.park_uuid = this.park_uuid
			}
			this.$api.my.firstAgentList(params).then(res=>{
				if(res.code == 200){
					this.firstLevelAgentList = res.result
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
.page_hezuo .upload_images.has-name{
	align-items: center;
}
.page_hezuo .upload_images.has-name .up-name{
	margin-right: .2rem;
}
.page_hezuo .btns-wrap{
	display: flex;
    align-items: center;
}
.page_hezuo.page .btns-wrap .big_btn{
	width: 3rem;
}
.page_hezuo.page .btns-wrap .pre-btn{
	background: transparent;
    color: #999;
    border: 0.0267rem solid #999;
}
.page_hezuo .img_box {
	margin-top: 0.2rem;
	overflow: unset;
}
.page_hezuo .img_box .img_bu{
	height: 2.05rem;
	position: relative;
}
.page_hezuo .img_box .img_bu .van-icon{
	position: absolute;
	top: -0.134rem;
	right: -0.1rem;
}
.page_hezuo .img_box .img_bu .image{
	width: 2.05rem;
    height: 2.05rem;
	object-fit: contain;
}
.page_hezuo .icon-add{
	margin-top: 0.2rem;
}
.page_hezuo .upload_images{
	flex-wrap: wrap;
}
</style>
